import React from 'react';
export function Header() {
  return <header className="w-full py-8 text-center border-b border-warmBrown/10 bg-cream" data-id="element-59">
      <h1 className="font-handwritten text-5xl md:text-6xl text-forestGreen mb-2" data-id="element-60">
        Napftagebuch
      </h1>
      <p className="font-serif text-warmBrown italic text-lg md:text-xl" data-id="element-61">
        Ehrliche Geschichten aus dem Hundealltag
      </p>
    </header>;
}